import CRUDService from 'src/services/CRUDService';

export interface EnabledReport {
  savedSearchId: string;
  newFollowersOnly: boolean;
}

export interface SftpConfig {
  host: string;
  port: number;
  path: string;
  authMethod: 'password' | 'ssh_key';
  username: string;
  password?: string;
  sshKey?: string;
}

export interface S3Config {
  bucketName: string;
  prefix: string;
  authMethod: 'bucket_policy' | 'credentials';
  accessKeyId?: string;
  secretKey?: string;
  region: string;
}

export interface ReportIntegration {
  id: string;
  universityId: string;
  type: 's3' | 'sftp';
  name: string;
  enabledReports: EnabledReport[];
  sftpConfig?: SftpConfig;
  s3Config?: S3Config;
}

class ReportIntegrationService extends CRUDService<ReportIntegration> {
  async testIntegration(
    integration: Partial<ReportIntegration>
  ): Promise<{message?: string} | null> {
    return this.custom<{message?: string} | null>('test', {}, 'post', integration);
  }
}

export default new ReportIntegrationService({baseUrl: '/v1/report-integrations', useJWT: true});
